<div class=" row border-bottom pl-1 pr-1 ml-1 mr-1">
	
	<div class="row justify-content-end w-100">
		<ng-container *ngIf="!sending">
			<button class="btn btn-success btn-h" (click)="exportXls();"><i class="fa fa-file-excel-o"></i></button>
			&nbsp;&nbsp;
			<button class="btn btn-danger btn-h" (click)="exportPdf();"><i class="fa fa-file-pdf-o"></i></button>
		</ng-container>
		<ng-container *ngIf="sending">
			<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</ng-container>
		&nbsp;&nbsp;
		<mat-form-field appearance="outline" class="float-right w-25">
			<input matInput [formControl]="search" placeholder="Search for customer...">
			<button matSuffix mat-icon-button aria-label="Clear" (click)="search.setValue('')">
			<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
	</div>
		

		
	
	

	<div class="table" #print_table>
		<table class="table table-sm">
			<thead class="sticky-header thead-dark">
				<tr>
					<th class="sticky-header">Customer#</th>
					<th class="sticky-header">Name</th>
					<th class="sticky-header">Address1</th>
					<th class="sticky-header">Address2</th>
					<th class="sticky-header">Address3</th>
					<th class="sticky-header">Address4</th>
					<th class="sticky-header">Address5</th>
					<th class="sticky-header">Tax Ref</th>
				</tr>
			</thead>
			<tbody>
			<tr *ngFor="let d of filtereddata">
				<td>
					<a [routerLink]="'/customers/view/'+d.debtorno">{{ d.debtorno}}</a></td>
				<td>{{ d.name}}</td>
				<td>{{ d.address2}}</td>
				<td>{{ d.address3}}</td>
				<td>{{ d.address4}}</td>
				<td>{{ d.address5}}</td>
				<td>{{ d.taxref}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</div>